import './App.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {Login} from "./pages/Login";
import {Logout} from "./pages/Logout";
import {VerifyGoogleLogin} from "./pages/VerifyGoogleLogin";
import WithRequireAuthentication from "./services/auth/WithRequireAuthentication";
import {Home} from "./pages/Home";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Switch>
                    <Route path="/login" render={() => <Login/>}/>
                    <Route path="/logout" render={() => <Logout/>}/>
                    <Route path="/verify-google-login" render={() => <VerifyGoogleLogin/>}/>
                    <Route path="*" render={() => <WithRequireAuthentication><Home/></WithRequireAuthentication>}/>
                </Switch>
            </BrowserRouter>
        </div>
    );
}

export default App;
